export default __webpack_public_path__ + "static/media/GetStarted_HeroBanner_Image.49e32056.png";